import type { IndustrialCaseDocument } from '@/domain/industrialCase/industrialCaseDocument';
import { toIndustrialCaseSummary } from '@/domain/industrialCase/industrialCaseSummary';
import { useRouter } from '@/routing/useAppRouter';
import { useQuery } from '@tanstack/react-query';

import {
  fetchPublishedIndustrialCases,
  filterIndustrialCasesByLanguage,
} from '@/apis/industrialCases';

export function selectIndustrialLandingCases(
  documents: ReadonlyArray<IndustrialCaseDocument>,
  language: IndustrialCaseDocument['language'],
) {
  return filterIndustrialCasesByLanguage(documents, language)
    .filter((document) => document.solution === 'industrial')
    .map(toIndustrialCaseSummary);
}

/** Keeps authored prose in its own language and propagates failures to retry UI. */
export function usePublishedIndustrialCaseCards() {
  const { locale } = useRouter();
  const language = locale === 'ko' ? 'ko' : 'en';

  return useQuery({
    queryKey: ['published-industrial-cases', language],
    queryFn: fetchPublishedIndustrialCases,
    select: (documents) => selectIndustrialLandingCases(documents, language),
    staleTime: 60_000,
    retry: 1,
  });
}
